/* 🤖 this file was generated by svg-to-ts */
export const matIconCrop32: {
  name: 'crop-3-2';
  data: string;
} = {
  name: 'crop-3-2',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"/></svg>`
};
